import React, { Component } from "react"
import Svg from "../../shared/_svgs/svg"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"

export class ItineraryContentBlockNoInformation extends Component {
  constructor(props) {
    super(props)

    this.state = {
      block: props.block,
    }

    this.handleClickTracking = this.props.handleClickTracking.bind(this)
    this.showSignupModal = this.props.showSignupModal.bind(this)
  }

  handleClick() {
    this.handleClickTracking(this.props.block.buttonTracking)
    this.showSignupModal()
  }

  render() {
    const buttonSvg = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonIcon)
    const buttonColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonColor)
    const boxBackgroundColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.backgroundColor)
    return (
      <div className={`departure-info__essentials__critical-info__no-information ${boxBackgroundColor}`}>
        <img src="/static/criticalclock.svg" />
        <h5>{this.props.block.heading}</h5>
        <span className="rich-text">
          <p>{this.props.block.text}</p>
        </span>
        {this.state.block.buttonText ? (
          <div className="cta-button">
            <a
              className={`button button--small rm-this-class rm-this-class-hide-default ${buttonColor ? buttonColor : "casc-blue"}`}
              onClick={() => this.handleClick()}
            >
              {buttonSvg !== "" ? <Svg iconName={buttonSvg} /> : ""}
              <span className="text">{this.props.block.buttonText}</span>
            </a>
          </div>
        ) : (
          ""
        )}
      </div>
    )
  }
}
